import { GameUser } from '@battletris/shared';

const GameRegistry: GameUser[] = [];

export default GameRegistry;
